import { SET_FLOOR_DATA } from "../ActionName/ActionName";


const initialState = {
    doc: {},
}

const FloorReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_FLOOR_DATA:
            return ({ ...state, doc: action.value, timestamp: Date.now() })
      
        default:
            return state;
    }
}

export default FloorReducer;